<template>
  <div class="row-bookmanagement">
    <!-- <LeftListSupplier  /> -->
    <LeftListSupplier :pos="4"></LeftListSupplier>
    <div class="g-row2">
      <div class="m-hone1 m-bookmanagement">
        <ul class="g-tablist1">
          <li class="li ">
            <router-link to="/suppliercenter-onlinebook" class="txt">新建目录</router-link>
          </li>
          <li class="li on">
            <router-link to="/suppliercenter-bookmanagement" class="txt">目录管理</router-link>
          </li>
<!--          <li class="li">-->
<!--            <router-link to="/suppliercenter-submittedorder" class="txt">订单管理</router-link>-->
<!--          </li>-->
        </ul>
        <div class="contect g-contecte1">
          <div class="m-table">
            <div class="top">
              <div class="tit">目录管理</div>
              <div class="btn" @click="batchDel">批量删除</div>
            </div>
            <div class="top" style="justify-content: flex-start;">
              <div class="tit">订单检索：</div>
              <a-input-search class="m-so" placeholder="请输入客户名称" v-model="search.customerName" @search="load(1)" />
            </div>
            <div class="inner">
              <a-table class="m-tablebooknanagement" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" rowKey="id" :columns="columns"
              :data-source="data" :pagination="false" :bordered="false"
              :scroll="{ x: 700 }">
              <div slot="updatetime" class="date" slot-scope="desc, record, indent, expanded,">
                {{(record.updatetime||'').split(' ')[0]}}  <span class="time">{{(record.updatetime||' ').split(' ')[1]}}</span>
              </div>
              <div slot="status" slot-scope="desc, record, indent, expanded,"
                :style="{ color: record.supplierStatus>0 ? '#9FA6AF' : '#222529' }">
                <span class="status">{{ record.supplierStatusOptionName }}</span>
              </div>
              <div slot="leadingin" slot-scope="leadingin, record, indent, expanded" class="leadingin" style="color:#1690FF;">
                <span v-if="record.supplierStatus==0" @click="showModal(record)"> 导入 </span>
                <span v-else @click="viewDetail(record)"> 查看 </span>
              </div>
              <div slot="delete" slot-scope="index, record, indent, expanded" class="delete" style="color: #1690FF;">
                <span @click="del(record.id)">删除</span>
              </div>
            </a-table>
            </div>
          </div>
          <mPages :page.sync="filter.page" :page-size.sync="filter.pageSize" :total="dataCount" />
        </div>
      </div>

    </div>
    <!-- 弹窗 -->
    <a-modal :visible="visible" @ok="load()" class="m-pope1" @cancel="handleCancel" :footer="null" :centered="true"
      :closable="false" :width="895">
      <div class="inner">
        <div class="tit">导入目录</div>
        <div class="info">导入.xlsx文件（Excel表格，每行一条书目），图书目录条件模版<a href="/static/bkHome/template/bookImportTemplate.xlsx" download style="color:blue;text-decoration-line: underline;">点击下载</a></div>
<!--        <a-upload name="file" :multiple="true" action="https://www.mocky.io/v2/5cc8019d300000980a055e76"-->
<!--          :headers="headers" @change="handleChange">-->
<!--          <a-button>河南大学2004年春季图书采购项目1..xls</a-button>-->
<!--        </a-upload>-->
        <file-upload accept=".xlsx" v-model="fileUrl" :show-file-list="true" style="position: relative">
          <a-button>
            <div v-if="!fileUrl" class="pic">
              <img src="@/assets/images/e-load3.png" class="img" alt="" />
            </div>
            <div v-if="!fileUrl" class="btn1">点击选择文件</div>
          </a-button>
        </file-upload>
        <button class="btn" v-loading="saving" @click="importBooks">确认提交</button>
        <div class="info1">注：提交后目录列表状态显示为已上传</div>
      </div>
    </a-modal>

    <!--查看弹窗-->
    <a-modal :visible="viewVisiable" @ok="viewVisiable=false" @cancel="viewVisiable=false" :footer="null" :centered="true"
      :closable="false" :width="895">
      <div class="m-popod1">
        <div class="top1" style="background: none; box-shadow: none;">
          <div class="tit1">查重</div>
          <div class="close" @click="viewVisiable=false"><img src="@/assets/images/cls.png" class="icon" alt="" /></div>
        </div>
        <div class="inner" style="overflow: auto">
          <div class="m-table m-table-lib" style="width: 100%;">
            <a-table :columns="detailColumns" :data-source="detailData" :pagination="false" :bordered="false"
            >
              <div slot="supplier" slot-scope="supplier, record, indent, expanded">
                <a @click="openSupplier(order.customerInfo.uid)" class="supplier" >{{ order.customerInfo.realname }}</a>
              </div>
            </a-table>
            <mPages :page.sync="detailPage.page" :page-size.sync="detailPage.pageSize" :total="detailPage.count" />
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import LeftListSupplier from "@/components/LeftListSupplier";
import mPages from '@/components/mpages/mPages.vue'
import {getApiData, getApiRes} from "@/api/apiUtil";
import apiBkBookCart from "@/api/bkBookCart";
import apiBkBookChoose from "@/api/bkBookChoose";
import FileUpload from "@/views/common/FileUpload.vue";
import apiBkBook from "@/api/bkBook";
import apiBkCompany from "@/api/bkCompany";
import apiUserInfo from "@/api/userInfo";
export default {
  components: {
    FileUpload,
    LeftListSupplier,
    mPages,
  },
  data() {
    return {
      ModalText: "Content of the modal",
      visible: false,
      confirmLoading: false,
      // 单选

      // 表单
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        name: '',
        name2: '',
        name3: '',
        name4: '',
        region: undefined,
        region2: undefined,
      },
      // 表格
      selectedRowKeys: [], // Check here to configure the default column
      columns: [
        {
          title: "目录名称",
          dataIndex: "title",
          key: "order",
          width: '21.6%',

        },
        {
          title: "客户",
          dataIndex: "customerInfo.shortName",
          key: "customerInfo.shortName",
          width: '16.9%',
          ellipsis: true,
        },
        {
          title: "更新时间",
          dataIndex: "updatetime",
          key: "updatetime",
          width: '15.5%',
          ellipsis: true,
          scopedSlots: { customRender: 'updatetime' },
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          ellipsis: true,
          width: '16.2%',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: "操作",
          dataIndex: "value4",
          key: "value4",
          ellipsis: true,
          width: '4.1%',
          scopedSlots: { customRender: 'leadingin' },
        },
        {
          title: " ",
          dataIndex: "value5",
          key: "value5",
          ellipsis: true,
          width: '21.6%',
          scopedSlots: { customRender: 'delete' },
        },

        // {
        //   title: "净值走势图",
        //   dataIndex: "change7",
        //   scopedSlots: { customRender: 'echarts' },

        //   key: "change7",
        //   ellipsis: true,
        // },
      ],
      data: [],
      dataCount: 0,
      saving: false,
      fileUrl: '',
      search: {
        supplier: '',
        customerName: '',
      },
      filter: {
        isCustomerInfo: true,
        page: 1,
        pageSize: 20,
        order: undefined
      },
      currentData: {},
      company: {id: 0},

      // 查看
      viewVisiable: false,
      detailColumns: [
        {
          title: "ISBN",
          dataIndex: "isbn",
          key: "isbn",
          width: 100,

        },
        {
          title: "书名",
          dataIndex: "name",
          key: "name",
          width: 120,
          // ellipsis: true,
        },
        {
          title: "出版社",
          dataIndex: "publisher",
          key: "publisher",
          width: 100,
          ellipsis: true,
        },
        {
          title: "作者",
          dataIndex: "author",
          key: "author",
          ellipsis: true,
          width: 87,
        },

        {
          title: "发行时间",
          dataIndex: "publishDate",
          key: "publishDate",
          ellipsis: true,
          width: 80,
        },

        // {
        //   title: "印刷日期",
        //   dataIndex: "printDate",
        //   key: "printDate",
        //   ellipsis: true,
        //   width: 80,
        // },
        {
          title: "开本",
          dataIndex: "pageSize",
          key: "pageSize",
          ellipsis: true,
          width: 60,
        },
        {
          title: "开本",
          dataIndex: "pageSize",
          key: "pageSize",
          ellipsis: true,
          width: 60,
        },
        {
          title: "定价",
          dataIndex: "price",
          key: "price",
          ellipsis: true,
          width: 60,
        },
        {
          title: "折扣",
          dataIndex: "discount",
          key: "discount",
          ellipsis: true,
          width: 60,
        },
        // {
        //   title: "客户",
        //   dataIndex: "customer",
        //   key: "customer",
        //   ellipsis: true,
        //   width: 230,
        //   scopedSlots: { customRender: 'supplier' },
        // },
        {
          title: "订单数",
          dataIndex: "num",
          key: "num",
          ellipsis: true,
          width: 40,
        },
      ],
      detailData: [],
      detailPage: {
        page: 1,
        pageSize: 100,
        count: 0,
      }
    };
  },
  computed: {},
  watch: {
    filter:{
      handler() {
        this.load()
      },
      deep: true
    },
    detailPage: {
      deep: true,
      handler() {
        this.viewDetail(this.currentData, this.detailPage.page)
      }
    }
  },
  mounted() {
    this.load(1)
    this.loadCompany()

    // 检测认证
    if(this.$store.state.user.userInfo.type != 2 && this.$store.state.user.company.status != 2) { //会员和供应商需要认证
      return this.$alert('请先完成资质认证', '提示', {callback:()=>this.$router.push(this.$store.state.user.userInfo.type == 1 ? '/info-qualifications' : '/center-qualifications')})
    }
  },
  methods: {
    async load(page=undefined){
      if(page) this.filter.page = page
      let map = await this.getMap()
      // if(this.search.supplier) map.push(['supplier','like',`%${this.search.supplier}%`])
      let re = await getApiRes(apiBkBookChoose.getList(undefined,undefined,map,'',[],this.filter), 0, 1,1)
      this.data = re.data
      this.dataCount = re.count
    },
    async getMap(){
      let map = []
      // 搜索客户
      if(this.search.customerName){
        let re = await getApiRes(apiUserInfo.search(this.search.customerName, 1, 10))
        if(re.code==0){
          let uids = []
          re.data.forEach(v=>{
            // if(v.userInfo.type==2)
              uids.push(v.userInfo.uid)
          })
          if(uids.length===0) uids=[-1]
          map.push(['customerUid','in', uids])
        }
      }
      return map
    },
    async batchDel(){
      if(this.selectedRowKeys.length==0) return this.$message.error('请选择要删除的数据')
      let reConfirm = await this.$confirm('确定要删除吗?').catch((e)=>false)
      if(!reConfirm) return
      let re = await getApiRes(apiBkBookChoose.listDel(this.selectedRowKeys),0,1,1,1)
      if(re.code==0){
        this.load()
      }
    },
    async del(id){
      let reConfirm = await this.$confirm('确定要删除吗?').catch((e)=>false)
      if(!reConfirm) return
      let re = await getApiRes(apiBkBookChoose.listDel(id),0,1,1,1)
      if(re.code==0){
        this.load()
      }
    },
    async importBooks(){
      if(!this.checkCompanyAuth()) return this.$alert('请先完成资质认证', '提示', {callback:()=>this.$router.push(this.$store.state.user.userInfo.type == 1 ? '/info-qualifications' : '/center-qualifications')})
      if(this.saving) return
      if(!this.fileUrl) return this.$message.error('请选择文件')
      this.saving = true;
      let re = await getApiRes(apiBkBookChoose.importBook(this.fileUrl, this.currentData.id),0,1,0,0)
      this.saving = false;
      this.fileUrl = ''
      this.visible = false
      if(re.code==0){
        this.load()
        this.$success({
          title: '成功',
          content: re.msg
        })
      }else{
        this.$error({
          title: '失败',
          content: re.msg
        })
      }
    },
    async viewDetail(row, page=1){
      this.currentData = row
      this.viewVisiable = true
      let re = await getApiRes(apiBkBookChoose.getDetailList(row.id, page, this.detailPage.pageSize),0,1)
      this.detailData = re.data
      this.detailPage.count = re.count
      // if(page == 1) this.detailData = []
      // this.detailData.push(...list)
      // let data = await getApiData(apiBkBookChoose.getList(1,1,[['id','=',row.id]],'',[],{isCustomerDetail: 1}),0,1)
      // if(data && data.length>0){
      //   this.detailData = data[0].customerDetailList
      // }
    },
    async loadCompany(){
      if(!this.company.id){
        this.company = await getApiData(apiBkCompany.getInfo(),0,0,0,0)
        this.$store.dispatch('user/updateCompany', this.company)
      }
    },
    checkCompanyAuth(){
      return this.company.status==2
    },
    showModal(row) {
      this.currentData = row
      this.visible = true;
    },
    handleCancel(e) {
      this.visible = false;
    },
      // 表格
    onSubmit() {
      console.log('submit!', this.form);
    },
    // 表格
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },

  },
};
</script>

<style lang="scss" scoped>
//.ant-input-affix-wrapper .ant-input-suffix {
//  right: 0;
//}
::v-deep .el-upload{
  width: 100%;height: 2.78667rem;
}
::v-deep .el-upload-list{
  position: absolute;
  top:1.1rem;
  z-index: 11;
  //width: 100%;
  padding: 0 80px;
}
::v-deep .ant-table table{
  display: block;
  width: 100%;
  overflow-x: auto;
}
.m-popod1 .top1{
  padding: 0;
}
.m-popod1 .inner{
  padding: 0;
  max-height: 80vh;
  overflow-y: auto;
}

</style>
